import Box from "./Box";
import FormError from "./FormError";
import GridItem from "./GridItem";
import PropTypes from "prop-types";
import React from "react";
import RoundedInput from "./RoundedInput";
import Text from "./Text";

function FormInput({
  autoComplete,
  label,
  name,
  handleChange,
  placeholder,
  type,
  value,
  error,
}) {
  return (
    <Box position="relative">
      {error && typeof error === "string" && (
        <FormError
          name={name}
          positionProps={{ top: "-20px", left: [0, null, null, 52] }}
        >
          {error}
        </FormError>
      )}
      <RoundedInput
        type={type}
        name={name}
        autoComplete={autoComplete}
        onChange={handleChange}
        placeholder={placeholder}
        value={value}
        error={error !== null && error !== undefined}
      />
      <GridItem gridColumnStart={2} px={[null, null, null, 52]} pt={20}>
        <Text>{label}</Text>
      </GridItem>
    </Box>
  );
}

FormInput.propTypes = {
  autoComplete: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  handleChange: PropTypes.func.isRequired,
  placeholder: PropTypes.string.isRequired,
  type: PropTypes.string.isRequired,
  error: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
};

export default FormInput;
